module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub-main take-place column actualities"
  }, [_c('div', {
    staticClass: "ctn-layout column"
  }, [_c('div', {
    staticClass: "menu-actu row"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showModalShareNews = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-diffusion"
  }), _vm._v("\n\t\t\t\t\tDiffuser un article\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "actualities-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\tLes derniers articles de Patrimoffice\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-main-articles row"
  }, _vm._l((_vm.newNews), function(article, key) {
    return _c('router-link', {
      key: key,
      staticClass: "article-main",
      attrs: {
        "to": {
          name: 'Article',
          params: {
            id: article.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "ctn-cover"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-article"
    }, [_c('div', {
      staticClass: "head-article row"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "icon-clock"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(article.updated_at, 'DD/MM/YY')) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "icon-paysage-vous"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(article.author.name) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "title-article"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(article.title) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "ctn-tags row"
    }, _vm._l((article.tags), function(tag, keyt) {
      return _c('div', {
        key: keyt,
        staticClass: "tag"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t\t\t\t\t")])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "ctn-description",
      domProps: {
        "innerHTML": _vm._s(_vm.strip(article.body))
      }
    })])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles-container row"
  }, [_c('div', {
    staticClass: "ctn-small-articles-part"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tTous les articles de Patrimoffice\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles"
  }, _vm._l((_vm.restNews), function(article, key) {
    return _c('div', {
      key: key,
      staticClass: "small-article row"
    }, [_c('div', {
      staticClass: "ctn-cover"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ctn-title column"
    }, [_c('div', {
      staticClass: "article-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "header-article row"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "icon-clock"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(article.updated_at, 'DD/MM/YY')) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "icon-paysage-vous"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(article.author.name) + "\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "ctn-cta"
    }, [_c('router-link', {
      staticClass: "btn btn-gold",
      attrs: {
        "to": {
          name: 'Article',
          params: {
            id: article.id
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tVoir l'article\n\t\t\t\t\t\t\t\t\t")])], 1)])
  }), 0), _vm._v(" "), (_vm.restNews.length === 0) ? _c('div', {
    staticClass: "no-article"
  }, [_vm._v("\n\t\t\t\t\t\t\tPas encore d'articles partagés\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles-part"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tLes derniers articles partagés\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles"
  }, [_vm._l((_vm.myNews), function(article, key) {
    return _c('div', {
      key: key,
      staticClass: "small-article row"
    }, [_c('div', {
      staticClass: "ctn-cover"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ctn-title column"
    }, [_c('div', {
      staticClass: "article-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "header-article row"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "icon-clock"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(article.updated_at, 'DD/MM/YY H:m')) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "icon-paysage-vous"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(article.author.name) + "\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "ctn-cta"
    }, [_c('a', {
      staticClass: "btn btn-gold",
      attrs: {
        "href": article.link,
        "target": "_blank"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tVoir l'article\n\t\t\t\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.myNews.length === 0) ? _c('div', {
    staticClass: "no-article"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPas encore d'articles partagés\n\t\t\t\t\t\t\t")]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showModalShareNews,
      "content": _vm.modalShareNews
    },
    on: {
      "close": function($event) {
        _vm.showModalShareNews = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdaef3c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Actualities/Actualities.vue
// module id = 1186
// module chunks = 0